/**
 * Centralized email validation utilities
 */

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates email format using the centralized regex
 */
export function isValidEmail(email: string): boolean {
  return EMAIL_REGEX.test(email);
}

/**
 * Validates email format and returns error message if invalid
 */
export function validateEmail(email: string): string | null {
  if (!email || email.trim() === '') {
    return 'Email is required';
  }

  if (!isValidEmail(email)) {
    return 'Please enter a valid email address';
  }

  return null;
}

/**
 * Validates that required fields are present and non-empty
 * Re-exported from common for backward compatibility
 */
export function validateRequiredFields(
  fields: Record<string, unknown>
): string | null {
  for (const [fieldName, value] of Object.entries(fields)) {
    const isFalsy = !value;
    const isStringAndEmpty = typeof value === 'string' && value.trim() === '';
    if (isFalsy || isStringAndEmpty) {
      return `${fieldName} is required`;
    }
  }
  return null;
}

/**
 * Validates email format for username fields (same as email validation)
 */
export function validateUsername(username: string): string | null {
  if (!username || username.trim() === '') {
    return 'Username is required';
  }

  if (username.length < 3) {
    return 'Username must be at least 3 characters';
  }

  if (/\s/.test(username)) {
    return 'Username cannot contain spaces';
  }

  if (!isValidEmail(username)) {
    return 'Please enter a valid email address';
  }

  return null;
}
